import React from 'react'
import PropTypes from 'prop-types'
import { FoodItem } from '~/components'
import { Box } from '@mui/system'

const Default = ({ data = [] }) => {
  return (
    <Box>
      {data.map((item) => (
        <FoodItem {...item} key={item.id} />
      ))}
    </Box>
  )
}

Default.propTypes = {
  data: PropTypes.array,
}

export default Default
